import { useEffect } from "react";
import { Route, createBrowserRouter, RouterProvider, createRoutesFromElements } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// helpers
import { hotelPanelRootUrl, pagesUrl } from "../utils/panel-helpers/helpers";
// Layout
import AppLayout from "../../components/AppLayout";
import AppLayoutAuthenticated from "../../components/AppLayout/AppLayoutAuthenticated";
// Pages
import Login from "../../pages/Login";
import ResetPassword from "../../pages/ResetPassword";
import StoreNewPasswordPage from "../../pages/ResetPassword/StoreNewPasswordPage";
import InvalidToken from "../../pages/ResetPassword/InvalidToken";
// Pages Authenticated
import Dashboard from "../../pages/Dashboard/Dashboard";
import Bookings from "../../pages/Bookings";
import Settings from "../../pages/Settings";
import Logins from "../../pages/Logins";
import AddLogin from "../../pages/Logins/AddLogin";
import EditLogin from "../../pages/Logins/EditLogin";
import Employees from "../../pages/Employees/Employees";
import AddEmployee from "../../pages/Employees/AddEmployee";
import EditEmployee from "../../pages/Employees/EditEmployee";
import Offers from "../../pages/Offers";
import AddEditOffer from "../../pages/Offers/AddEditOffer/AddEditOffer";
import Marketplace from "../../pages/Marketplace";
// Private Protected Routes
import PrivateStoreNewPasswordRoute from "./privateRoutes/PrivateStoreNewPasswordRoute";
import PrivateLoginsRoute from "./privateRoutes/PrivateLoginsRoute";
import PrivateEmployeesRoute from "./privateRoutes/PrivateEmployeesRoute";
import PrivateOffersRoute from "./privateRoutes/PrivateOffersRoute";
// Actions
import { loginActionCreators } from "../../pages/Login/loginModule";

function AppRouter(props: any) {
  useEffect(() => {
    props.checkUserLoggedInAction();
  }, []);

  return (
    <RouterProvider
      router={createBrowserRouter(
        createRoutesFromElements(
          <Route>
            {/* NON-Authenticated routes */}
            <Route element={<AppLayout />}>
              <Route path={`/${hotelPanelRootUrl}/${pagesUrl.login}`} element={<Login />} />
              <Route path={`/${hotelPanelRootUrl}/${pagesUrl.resetPassword}`} element={<ResetPassword />} />
              <Route
                path={`/${hotelPanelRootUrl}/${pagesUrl.storeNewPassword}`}
                element={
                  <PrivateStoreNewPasswordRoute>
                    <StoreNewPasswordPage />
                  </PrivateStoreNewPasswordRoute>
                }
              />
              <Route path={`/${hotelPanelRootUrl}/${pagesUrl.invalidToken}`} element={<InvalidToken />} />
            </Route>

            {/* Authenticated routes */}
            <Route element={<AppLayoutAuthenticated />}>
              <Route path={`/${hotelPanelRootUrl}/${pagesUrl.dashboard}`} element={<Dashboard />} />
              <Route path={`/${hotelPanelRootUrl}/${pagesUrl.bookings}`} element={<Bookings />} />
              <Route>
                <Route path={`/${hotelPanelRootUrl}/${pagesUrl.offers}`} element={<Offers />} />
                <Route path={`/${hotelPanelRootUrl}/${pagesUrl.newOffer}`} element={<AddEditOffer />} />
                <Route
                  path={`/${hotelPanelRootUrl}/${pagesUrl.editOffer}`}
                  element={
                    <PrivateOffersRoute>
                      <AddEditOffer />
                    </PrivateOffersRoute>
                  }
                />
              </Route>
              <Route>
                <Route path={`/${hotelPanelRootUrl}/${pagesUrl.logins}`} element={<Logins />} />
                <Route path={`/${hotelPanelRootUrl}/${pagesUrl.addLogins}`} element={<AddLogin />} />
                <Route
                  path={`/${hotelPanelRootUrl}/${pagesUrl.editLogins}`}
                  element={
                    <PrivateLoginsRoute>
                      <EditLogin />
                    </PrivateLoginsRoute>
                  }
                />
              </Route>
              <Route>
                <Route path={`/${hotelPanelRootUrl}/${pagesUrl.employees}`} element={<Employees />} />
                <Route path={`/${hotelPanelRootUrl}/${pagesUrl.addEmployee}`} element={<AddEmployee />} />
                <Route
                  path={`/${hotelPanelRootUrl}/${pagesUrl.editEmployee}`}
                  element={
                    <PrivateEmployeesRoute>
                      <EditEmployee />
                    </PrivateEmployeesRoute>
                  }
                />
              </Route>
              <Route path={`/${hotelPanelRootUrl}/${pagesUrl.marketplace}`} element={<Marketplace />} />
              <Route path={`/${hotelPanelRootUrl}/${pagesUrl.settings}`} element={<Settings />} />
            </Route>
          </Route>
        )
      )}
    />
  );
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      checkUserLoggedInAction: loginActionCreators.checkUserLoggedInAction
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);
